import Vue from 'vue'
import Mask from './index.vue'
import popupManager from '../nd-popup-manager'

const MaskController = Vue.extend(Mask)

let instance

const createMask = (clickHandler, dom) => {
  if (clickHandler) {
    instance = new MaskController({
      propsData: {
        onMaskClick: clickHandler,
        zIndex: popupManager.generateIndex()
      }
    })
  } else {
    instance = new MaskController({
      propsData: {
        zIndex: popupManager.generateIndex()
      }
    })
  }

  instance.vm = instance.$mount()
  if (dom) {
    dom.appendChild(instance.vm.$el)
  } else {
    document.body.appendChild(instance.vm.$el)
  }

  return instance
}

export default createMask